import { Injectable } from "@angular/core";
import { HttpClient, HttpResponse } from "@angular/common/http";

export type Eula = {
  hash: string;
  version: string;
  text: string;
};

export type EulaAgreementPayload = {
  userId: number;
  eula: Omit<Eula, "text">;
};

export type EulaData = {
  acceptanceRequired: boolean;
  eula: Eula;
};

export type EulaResponse = {
  acceptanceId: string;
  message: string;
  alreadyAccepted: boolean;
};

@Injectable({
  providedIn: "root",
})
export class EulaService {
  private readonly EULA_API_URL = "/api/ofm/General/Eula";
  eulaAgreed: boolean = false;

  constructor(private http: HttpClient) {}

  public setEulaAgreed(agreementPayload: EulaAgreementPayload) {
    return this.http.post<EulaResponse>(
      `${this.EULA_API_URL}/Accept`,
      agreementPayload
    );
  }

  public getEulaAgreed(userId: number) {
    return this.http.get<EulaData>(
      `${
        this.EULA_API_URL
      }/Status?userId=${userId}`
    );
  }
}
